import axios from "axios";
import {
  FETCH_DATA_FAILURE,
  FETCH_DATA_REQUEST,
  FETCH_DATA_SUCCESS,
} from "../store/actionTypes";
import { encrypted } from "../utils/Utility";

// Redux action creators
export const fetchDataRequest = (api) => ({
  type: FETCH_DATA_REQUEST,
  api,
});

export const fetchDataSuccess = (api, data) => ({
  type: FETCH_DATA_SUCCESS,
  api,
  payload: data,
});

export const fetchDataFailure = (api, error) => ({
  type: FETCH_DATA_FAILURE,
  api,
  payload: error,
});

// Create request headers
const createConfig = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  };
};

export const fetchData = (url, api, body = null) => {
  return async (dispatch) => {
    dispatch(fetchDataRequest(api));
    const config = createConfig();

    try {
      let request;
      if (body) {
        const encryptedBody = {
          encryptedBody: encrypted.encrypt(JSON.stringify(body)),
        };
        request = await axios.post(url, encryptedBody, config);
      } else {
        request = await axios.get(url, config);
      }

      const decryptedData = JSON.parse(encrypted.decrypt(request.data.encryptedBody));
      dispatch(fetchDataSuccess(api, decryptedData));
    } catch (error) {
      dispatch(fetchDataFailure(api, error));
    }
  };
};

// Encrypted post
export const postData = (url, api, body = null) => {
  return async (dispatch) => {
    dispatch(fetchDataRequest(api));
    const config = createConfig();

    try {
      const encryptedBody = body
        ? { encryptedBody: encrypted.encrypt(JSON.stringify(body)) }
        : {};

      const response = await axios.post(url, encryptedBody, config);
      const decrypted = JSON.parse(encrypted.decrypt(response.data.encryptedBody));
      dispatch(fetchDataSuccess(api, decrypted));
      return decrypted;
    } catch (error) {
      dispatch(fetchDataFailure(api, error));
    }
  };
};


export const createFetchAction = (api) => {
  return (url, body = null) => async (dispatch) => {
    const config = createConfig();

    try {
      dispatch(fetchDataRequest(api));

      let response;
      if (body) {
        const encryptedBody = {
          encryptedBody: encrypted.encrypt(JSON.stringify(body)),
        };
        response = await axios.post(url, encryptedBody, config);
      } else {
        response = await axios.get(url, config);
      }

      const decryptedData = JSON.parse(encrypted.decrypt(response.data.encryptedBody));
      dispatch(fetchDataSuccess(api, decryptedData));
      return decryptedData;
    } catch (error) {
      dispatch(fetchDataFailure(api, error));
    }
  };
};

export const createPostAction = (api) => {
  return (url, body) => (dispatch) => {
    return postData(url, api, body)(dispatch);
  };
};

// API usage map
export const fetchAllCountries = createFetchAction("allCountriesDetail");
export const fetchAllLanguages = createFetchAction("allTranslatedLanguages");
export const fetchPlaceholder = createFetchAction("placeholderLanguage");
export const fetchSelectedPlaceholder = createFetchAction("selectedPlaceholderLanguage");
export const fetchLanguages = createFetchAction("allLanguages");

export const postFeedback = createPostAction("feedbackDetails");
export const sessionFeedback = createPostAction("totalFeedbackDetails");
export const postStartSession = createPostAction("startSessionDetails");
export const postChatbotQuery = createPostAction("chatbotDetails");

export const fetchLoggedInDetails = createFetchAction("loggedInDetails");
export const fetchModel = createFetchAction("getModel");

export const postCommentFeedback = createPostAction("feedbackCommentDetails");
export const postShowFeedback = createPostAction("showFeedback");
export const fetchPolicySign = createFetchAction("policySignDetails");
export const postSavePolicy = createPostAction("savePolicy");
export const fetchdropdownDetails = createFetchAction("dropdownDetails");
export const fetchQueryCard = createFetchAction("queryCardDetails");
export const postFilteredResponse = createPostAction("filteredResponseDetails");
